const DEFAULT_STYLE =
  "bg-primary-main text-white disabled:bg-primary-light disabled:text-primary-main py-[10px]";

const Button = ({
  className = "",
  children,
  useDefaultStyle = false,
  ...rest
}) => {
  return (
    <button
      className={`rounded-[12px] transition duration-300 ease-in-out  ${className} ${
        useDefaultStyle ? DEFAULT_STYLE : ""
      }`}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
